export default "__VITE_ASSET__8a64ad9d__"